module.exports = __webpack_public_path__ + "img/degreeLineBlueIcon.59f4010c.png";